import { Gig } from "../gig";

/**
 * Project_Entity type guard.
 *
 * @param {any} projectJson Project object from API
 * @returns {boolean} Return true if type is Project_Entity
 */
function validator(projectJson: unknown): projectJson is Project_Entity {
  if (typeof projectJson === "object" && projectJson != null) {
    Project_Entity.requiredFields.forEach((element) => {
      if (!Object.keys(projectJson).includes(element))
        throw new Error("Field ${element} is null or undefined");
    });
  }
  return true;
}

export default class Project_Entity {
  static requiredFields = [
    "id",
    "memberID",
    "seasonID",
    "name",
    "description",
    "coverURL",
    "contacts",
    "sourceID",
    "sourceRecordID",
    "missionID",
    "gigs",
    "createdAt",
    "updatedAt",
  ];

  constructor(projectJson: unknown) {
    if (validator(projectJson)) {
      this.id = projectJson.id;
      this.memberID = projectJson.memberID;
      this.seasonID = projectJson.seasonID;
      this.name = projectJson.name;
      this.description = projectJson.description;
      this.coverURL = projectJson.coverURL;
      // this.contacts = projectJson.contacts;
      this.sourceID = projectJson.sourceID;
      this.sourceRecordID = projectJson.sourceRecordID;
      this.missionID = projectJson.missionID;
      this.gigs = projectJson.gigs;
      this.createdAt = projectJson.createdAt;
      this.updatedAt = projectJson.updatedAt;
    } else {
      throw new Error(
        "Failed to create new instance of ${ Project_Entity.name }: ${e}"
      );
    }
  }

  id: number;
  memberID: number;
  seasonID: number;
  name: string;
  description: string;
  coverURL: string;
  // contacts: Array<Contact>;
  sourceID: number;
  sourceRecordID: number;
  missionID: number;
  gigs: Array<Gig>;
  createdAt: string;
  updatedAt: string;
}
